document.addEventListener('DOMContentLoaded', () => {
  const currentMediaQuery = Foundation.MediaQuery.current;

  if (currentMediaQuery === 'small' || currentMediaQuery === 'medium') {
    // Remove 'full-width' class from header elements
    const headerFullWidthElements = document.querySelectorAll('header .full-width');
    headerFullWidthElements.forEach((element) => {
      element.classList.remove('full-width');
    });

    // Set 'tabindex' and 'role' attributes for footer widget titles
    const footerWidgetTitles = document.querySelectorAll('footer .widget_nav_menu .widget-title');
    footerWidgetTitles.forEach((title) => {
      title.setAttribute('tabindex', '0');
      title.setAttribute('role', 'button');

      // Add event listener for keypress and click
      title.addEventListener('click', toggleMenu);
      title.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          toggleMenu.call(title, event);
        }
      });
    });

    // Function to toggle menu visibility
    function toggleMenu(event) {
      event.preventDefault();
      this.classList.toggle('active');
      const menu = this.parentNode.querySelector('.menu');
      if (menu) {
        const isVisible = menu.style.display === 'block';
        menu.style.display = isVisible ? 'none' : 'block';
        menu.style.transition = 'height 300ms ease'; // You can adjust this to mimic slideToggle
      }
    }
  }
});
